/* Tikadeau — auto-open cart drawer après n'importe quel /cart/add
   (y compris apps tierces type CustoMeow qui bypassent les events
   internes d'Horizon). Intercepte fetch + XMLHttpRequest. */
(function () {
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/i;

  function openCart() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') {
      try { d.open(); } catch (e) {}
    }
  }

  function isAddURL(u) {
    return ADD_RE.test(u || '');
  }

  /* fetch */
  if (window.fetch) {
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch(input, init);
      if (!isAddURL(url)) return p;
      return p.then(function (res) {
        if (res && res.ok) setTimeout(openCart, 250);
        return res;
      });
    };
  }

  /* XMLHttpRequest (apps qui n'utilisent pas fetch) */
  if (window.XMLHttpRequest) {
    var XHR = window.XMLHttpRequest;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__tkCartUrl = url;
      return origOpen.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      var self = this;
      if (isAddURL(self.__tkCartUrl)) {
        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) {
            setTimeout(openCart, 250);
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }
})();
